import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Header } from './Header'
import { Footer } from './Footer'
import { CustomCursor } from './CustomCursor'
import { CookieBanner } from './CookieBanner'
import { ChatBot } from './ChatBot'
import { ChatBotProvider } from '@/contexts/ChatBotContext'

export function Layout() {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  useEffect(() => {
    const style = document.createElement('style')
    style.textContent = `*, *::before, *::after { cursor: none !important; }`
    document.head.appendChild(style)
    return () => {
      document.head.removeChild(style)
    }
  }, [])

  return (
    <ChatBotProvider>
      <CustomCursor />
      <div className="flex min-h-screen w-full flex-col">
        <Header />
        <main id="main-content" className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
      <CookieBanner />
      <ChatBot />
    </ChatBotProvider>
  )
}
